import React from 'react';
import heroImage from '../../../../assets/images/partnership/hero/hero.jpg';
import './Hero.css';

const Hero = () => {
  return (
    <section className="partnership-hero">
      <img
        className="partnership-hero__bg"
        src={heroImage}
        alt=""
        aria-hidden="true"
      />
      <div className="partnership-hero__overlay" />

      <div className="partnership-hero__inner">
        <div className="partnership-hero__content">
          <p className="partnership-hero__eyebrow">Partnership</p>
          <h1 className="partnership-hero__title">
            Build Long-Term Value Together.
          </h1>
          <p className="partnership-hero__text">
            Unlock sustainable growth through a structured partnership model—
            supported by reliable technology, clear onboarding, and responsive
            service.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
